import { BasicButton, PrimaryButton, Stack, Text } from "@certn/cascadia";
import {
  Modal,
  DialogHeader,
  DialogContent,
  DialogFooter,
  Dialog,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useCanViewClientPortalPricing } from "../permissions/Permissions";
import { formatNullableCurrency } from "../../utils/formatNullableCurrency";
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  cost?: {
    amount: number | null;
    currency: string;
  };
  credentials: string[] | undefined;
}

export function UnlockCredentialsModal({
  isOpen,
  onClose,
  onSave,
  cost,
  credentials,
}: Props) {
  const { t } = useTranslation();
  const canViewClientPortalPricing = useCanViewClientPortalPricing();
  const amount = formatNullableCurrency(cost?.amount, {
    currency: cost?.currency ?? "USD",
    locale: "en-US",
    fallback: null,
  });

  return (
    <Modal isOpen={isOpen}>
      <Dialog>
        {({ close }) => (
          <>
            <DialogHeader onClose={onClose}>
              {t("Unlock credentials")}
            </DialogHeader>
            <DialogContent>
              <Stack gap="space-4">
                <Text style="global/body-primary">
                  {t("You are about to purchase the following credentials:")}
                </Text>
                <ul>
                  {credentials?.map((credential) => (
                    <li key={credential}>
                      <Text
                        className={styles.boldText}
                        style="global/body-primary"
                      >
                        {credential}
                      </Text>
                    </li>
                  ))}
                </ul>
                {canViewClientPortalPricing && amount && (
                  <Text style="global/body-primary">
                    {t("The cost to reveal these credentials is")}{" "}
                    <Text
                      color="background-success-strong"
                      className={styles.boldText}
                    >
                      {amount}
                    </Text>
                  </Text>
                )}
              </Stack>
            </DialogContent>
            <DialogFooter>
              <BasicButton onPress={onClose}>{t("Cancel")}</BasicButton>
              <PrimaryButton onPress={onSave}>
                {t("Pay and unlock")}
              </PrimaryButton>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}

const styles = {
  boldText: css({
    fontWeight: "var(--font-weight-bold)",
  }),
};
